module.exports = {
  "collabSidebarInteraction": {
    "name": "collab sidebar interaction",
    "class": "interaction",
    "properties": {
      "objectType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "hidden": {
        "type": "boolean",
        "isOptional": true
      },
      "from": {
        "type": "string",
        "isOptional": true
      },
      "position": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "shown deep commenting onboarding",
        "start deep commenting onboarding",
        "delay deep commenting onboarding",
        "dismiss deep commenting onboarding",
        "toggle hide sidebar",
        "move floating sidebar",
        "New comments while viewing asset",
        "close comment mode",
        "click update global notification settings",
        "render collaboration-sidebar"
      ],
      "disabledReason": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "collab-sidebar",
    "version": "1"
  }
};